<div class="ey-wrapper">
  <div class="ey-page">
    <div class="ey-nav">
      <app-nav-menu></app-nav-menu>
    </div>
    <div class="ey-body page-expanded" [ngClass]="{ 'nav-collapsed': !navigationService.navExpanded }">
      <app-toast-notifications></app-toast-notifications>
      <div class="ey-body-container">
        <div class="ey-toggle-container" [ngClass]="{ 'grid-collapsed': !navigationService.gridExpanded }">
          <span><app-user-login-logout></app-user-login-logout></span>
          <span
            *ngIf="navigationService.gridExpanded"
            role="button"
            tabindex="0"
            title="Toggle full width page mode"
            (click)="toggleFullScreenGrid()"
            aria-label="full screen"
          >
            <i class="material-icons fullscreen-icon" aria-hidden="true">fullscreen_exit</i>
          </span>
        </div>
        <app-study-block-ui *ngIf="uiBlocked$ | async" [blockThisUI]="uiBlocked$ | async"></app-study-block-ui>
        <!-- <p-blockUI [blocked]="uiBlocked$ | async">
      <p-progressSpinner></p-progressSpinner>
    </p-blockUI> -->
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </div>
    </div>
  </div>
  <div *ngIf="isDisplayFooter" class="row ey-footer-container">
    <div class="footerDisplayImage"><img src="assets/images/EY_Logo_Footer.png" alt="Logo" /></div>
    <div class="footerTextAlignment">
      <h2 class="ey-footer">© {{ currentYear }} EYGM Limited | All Rights Reserved.</h2>
      <h2 class="ey-footer">
        Please review the <a class="ey-footer-a" [routerLink]="['/privacynotice']">Privacy Statement</a> for additional information.
      </h2>
    </div>
  </div>
</div>
